import {Route, Routes, Navigate, Outlet} from 'react-router-dom'

import {isAuthorizedUser} from './utils/permissions'
import {useAuth} from '../modules/auth'

import {MasterLayout} from '../../_metronic/layout/Admin/MasterLayout'
import CieloMerchantPage from '../../pages/cieloMerchants'
import {CieloMerchantCreatePage} from '../../pages/cieloMerchants/create'
import {CieloMerchantEditPage} from '../../pages/cieloMerchants/update'
import ContractTermPage from '../../pages/contractTerms'
import {ContractTermCreatePage} from '../../pages/contractTerms/create'
import {ContractTermEditPage} from '../../pages/contractTerms/update'
import AdminProductPage from '../../pages/adminProducts/list'
import {ProductCreatePage} from '../../pages/adminProducts/create'
import {ProductEditPage} from '../../pages/adminProducts/update'
import AdminCategoryPage from '../../pages/adminCategories'
import {CategoryCreatePage} from '../../pages/adminCategories/create'
import {CategoryEditPage} from '../../pages/adminCategories/update'
import AdminMachinePage from '../../pages/adminMachines'
import {MachineCreatePage} from '../../pages/adminMachines/create'
import {MachineEditPage} from '../../pages/adminMachines/update'
import AdminRoomPage from '../../pages/adminRooms'
import {RoomCreatePage} from '../../pages/adminRooms/create'
import {RoomEditPage} from '../../pages/adminRooms/update'
import AdminFranchisePage from '../../pages/adminFranchises'
import {FranchiseCreatePage} from '../../pages/adminFranchises/create'
import {FranchiseEditPage} from '../../pages/adminFranchises/update'
import AdminPaymentOptionPage from '../../pages/adminPaymentOptions'
import {PaymentOptionCreatePage} from '../../pages/adminPaymentOptions/create'
import {PaymentOptionEditPage} from '../../pages/adminPaymentOptions/update'
import AdminGroupPage from '../../pages/adminGroups/list'
import {GroupShowPage} from '../../pages/adminGroups/show'
import AdminUserPage from '../../pages/adminUsers/list'
import {UserCreatePage} from '../../pages/users/create'
import {UserEditPage} from '../../pages/users/update'

const PermissionsGuard = ({permission}: {permission: string}) => {
  const {currentUser, currentFranchise} = useAuth()
  const isAuthorized = isAuthorizedUser(currentUser, permission)

  return isAuthorized ? <Outlet /> : <Navigate to='/error/404' />
}

const PrivateAdminRoutes = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route element={<PermissionsGuard permission='admin.access' />}>
          <Route path='cielo-merchants' element={<CieloMerchantPage />} />
          <Route path='cielo-merchants/create' element={<CieloMerchantCreatePage />} />
          <Route path='cielo-merchants/:id/edit' element={<CieloMerchantEditPage />} />
          <Route path='contract-terms' element={<ContractTermPage />} />
          <Route path='contract-terms/create' element={<ContractTermCreatePage />} />
          <Route path='contract-terms/:id/edit' element={<ContractTermEditPage />} />
          <Route path='products' element={<AdminProductPage />} />
          <Route path='products/create' element={<ProductCreatePage />} />
          <Route path='products/:id/edit' element={<ProductEditPage />} />
          <Route path='categories' element={<AdminCategoryPage />} />
          <Route path='categories/create' element={<CategoryCreatePage />} />
          <Route path='categories/:id/edit' element={<CategoryEditPage />} />
          <Route path='machines' element={<AdminMachinePage />} />
          <Route path='machines/create' element={<MachineCreatePage />} />
          <Route path='machines/:id/edit' element={<MachineEditPage />} />
          <Route path='rooms' element={<AdminRoomPage />} />
          <Route path='rooms/create' element={<RoomCreatePage />} />
          <Route path='rooms/:id/edit' element={<RoomEditPage />} />
          <Route path='franchises' element={<AdminFranchisePage />} />
          <Route path='franchises/create' element={<FranchiseCreatePage />} />
          <Route path='franchises/:id/edit' element={<FranchiseEditPage />} />
          <Route path='payment-options' element={<AdminPaymentOptionPage />} />
          <Route path='payment-options/create' element={<PaymentOptionCreatePage />} />
          <Route path='payment-options/:id/edit' element={<PaymentOptionEditPage />} />
          <Route path='groups' element={<AdminGroupPage />} />
          <Route path='groups/:id' element={<GroupShowPage />} />
          <Route path='users' element={<AdminUserPage />} />
          <Route path='users/create' element={<UserCreatePage isAdmin />} />
          <Route path='users/:id/edit' element={<UserEditPage isAdmin />} />
        </Route>
      </Route>
    </Routes>
  )
}

export {PrivateAdminRoutes}
